import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function useHomeResource(path, companyId, revision, shape = "object") {
  const [result, setResult] = useState({ companyId: null, status: "LOADING", data: null });
  useEffect(() => {
    if (!companyId) return;
    let active = true;
    const controller = new AbortController();
    setResult({ companyId, status: "LOADING", data: null });
    api.get(path, { signal: controller.signal, headers: { "x-company-id": companyId } })
      .then(({ data }) => {
        if (!active) return;
        const valid = shape === "array" ? Array.isArray(data) && data.every(item => item && typeof item === "object" && !Array.isArray(item))
          : data && typeof data === "object" && !Array.isArray(data);
        setResult({ companyId, status: valid ? "DATA" : "ERROR", data: valid ? data : null });
      }).catch(() => { if (active) setResult({ companyId, status: "ERROR", data: null }); });
    return () => { active = false; controller.abort(); };
  }, [path, companyId, revision, shape]);
  return result.companyId === companyId ? result : { status: "LOADING", data: null };
}
